<div class="ipm-auth-common-dev" [class.error-message]="shakeAnimation.showErrorMessage === true">
            <!-- <div class="ipm-switch-button">
                <mat-button-toggle-group name="switch-button"  [(ngModel)]="authDialogType" class="ipm-common-toggle-button"
                (ngModelChange)="onChangesLogin($event)"
                [disabled]="isStartSelling">
                    <mat-button-toggle value="login" class="common-btn" *ngIf="dialogType.openType !== 'start-selling'">Login</mat-button-toggle>
                    <mat-button-toggle value="signup" class="common-btn" >Signup</mat-button-toggle>
                </mat-button-toggle-group>
            </div> -->
            <div class="img-wrapper-auth">
                <img priority priority [src]="mainLogoName" alt="auth-logo">
            </div>
            <h2 class="heading-auth">
                {{ currentDialogType === 'login' ? 'Welcome back' : 'Create your account' }}
            </h2>

            <div class="error-message-data" *ngIf="shakeAnimation.errorMessage">
                {{shakeAnimation.errorMessage}}
            </div>

            <div *ngIf="currentDialogType === 'login' && !isOtpMode" class="set-login-margin">
                <ipm-login-signup [authType]="'login'" #loginFrom>
                    <div class="actions login-form-action" actions>
                        <div class="forgot-section">
                            <a (click)="openForgotChanges()">Forgot Password?</a>
                        </div>
                        <button mat-flat-button
                                color="primary"
                                class="primary-button ipm-submit-btn"
                                type="submit"
                                (click)='!loginFrom.authForm.valid ? loginFrom.authForm.markAllAsTouched() : authLogin(loginFrom.authForm)'>
                                Sign in
                        </button>
                        <button mat-button
                                class="ipm-text-btn"
                                type="button"
                                (click)="isOtpMode = true">
                                Sign in with OTP
                        </button>
                    </div>
                </ipm-login-signup>
            </div>
            
            <div *ngIf="currentDialogType === 'login' && isOtpMode" class="set-login-margin">
                <ipm-login-signup [authType]="'otp-login'" #otpLoginForm>
                    <div class="actions otp-form-action" actions>
                        <button mat-flat-button
                                color="primary"
                                class="primary-button ipm-submit-btn"
                                type="submit"
                                (click)='!otpLoginForm.authForm.valid ? otpLoginForm.authForm.markAllAsTouched() : authLoginWithOtp(otpLoginForm.authForm)'>
                                Send OTP
                        </button>
                        <button mat-button
                                class="ipm-text-btn"
                                type="button"
                                (click)="isOtpMode = false">
                                Sign in with Password
                        </button>
                    </div>
                </ipm-login-signup>
            </div>
            <div *ngIf="currentDialogType === 'signup'">

                <ipm-login-signup [authType]='currentDialogType'  #SignupFrom>
                    <div class="actions" actions>
                        <button mat-flat-button
                                color="primary"
                                class="primary-button ipm-submit-btn"
                                type="submit"
                                (click)='!SignupFrom.authForm.valid ? SignupFrom.authForm.markAllAsTouched() : authSignup(SignupFrom.authForm)'>
                                Sign up
                        </button>
                    </div>
                </ipm-login-signup>
            </div>
            <div class="divider line d-text" [class.login-section-divider]="currentDialogType === 'login'">
                Or
            </div>
            <div class="social-login-icon">
                <div class="social-login">
                    <li class="google" [hidden]="currentDialogType !== 'login'">
                        <div class="text-center" id="googleBtnDivLogin" data-width="100%" data-height="100%"></div>
                    </li>
                    <li class="google" [hidden]="currentDialogType !== 'signup'">
                        <div class="text-center" id="googleBtnDivSignup" data-width="100%" data-height="100%"></div>
                    </li>
                </div>
            </div>
            <p class="toggle-section-bottom">
                <ng-container *ngIf="currentDialogType  === 'login'">
                    New user? <a href="javacript:void(0)" (click)="onChangesLogin('signup')"> Sign up here</a>.
                </ng-container>
                <ng-container *ngIf="currentDialogType === 'signup'">
                    Existing user? <a href="javacript:void(0)" (click)="onChangesLogin('login')">Sign in here</a>.
                </ng-container>
            </p>
</div>
<ng-template #otpTemplate let-data>
    <ipm-otp-page [userInfo]="data"></ipm-otp-page>
</ng-template>
<ng-template #forgotPasswordTemplate>
    <ipm-forgot-password></ipm-forgot-password>
</ng-template>
<ng-template #producerJoinTemplate>
    <ipm-producer-join-form></ipm-producer-join-form>
</ng-template>
<ng-template #producerConfirmationTemplate>
    <ipm-producer-confirmation-popup></ipm-producer-confirmation-popup>
</ng-template>
<ng-template #notifyPopup let-data>
    <ipm-notify [data]="data"></ipm-notify>
</ng-template>
<ng-template #onboardingFlowTemplate>
    <ipm-onboarding-flow [userRole]="'producer'" [isBecomingProducer]="true" ></ipm-onboarding-flow>
</ng-template>
<ng-template #sellerConfirmationTemplate>
    <ipm-seller-confirmation-popup></ipm-seller-confirmation-popup>
</ng-template>
